<template>
  <div id="pageRoot" class="blind">
    <span class="normalTheme pageInstruction" style="left: 30px; top: 118px">
      <p>Escucha con atención este texto.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 30px; top: 180px">
      <p>Tacha las palabras que esten repetidas</p>
    </span>

	<img
	style="width:150px; top: 50px; left: 760px"
	class="pageElement"
	src="/pages/img/blindglo/assets_p36/mosca.svg"
	/>

    <p class="textBase appearAnimationB" id="crossingText" style="z-index: 6" ref="crossingText">
      Los sapos son animales que carecen de cola.
      Los sapos tienen cuatro patas. Los sapos tienen piel
      rugosa. La lengua de los sapos es pegajosa.
    </p>

    <p class="normal" style="left: 30px; top: 460px;">
        Entre todos escriban el texto en el pizarrón, dictándole al maestro.
	</p>

	<img
	style="width:600px; top: 600px; left: 0px"
	class="pageElement"
	src="/pages/img/blindglo/assets_p36/lengua.svg"
	/>

  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  top: 0px;
}
#crossingText {
  position: absolute;
  width: 785px;
  height: 214px;
  left: 30px;
  top: 263px;
  font-size: 35px;
  line-height: 45px;
  text-transform: uppercase;
  color: #2bb673;
}
</style>
<script>
	export default {
		data() {
			return {
				videos: [
					"glo/Video 154_155 b.mp4",
					"glo/Video 156b.mp4",
					"glo/Video 157b.mp4",
					"glo/Video 158.mp4",
				]
			};
		},
		methods:{
		dbId(name, option){
			return `${this.$parent.type}-${this.$parent.page}-${name}-${option}`
		},
		async loadOption(name, option) {
			var id = this.dbId(name, option);

			var value = await this.$db.options.get({
			id: id,
			}).catch(function(error){
			console.log("error getting option" + error);
			});
			if (value === undefined) return;
			console.log(value);

			if (value.option){
				this.crossWord(option);
			}

			console.log("option loaded: " + id + ", " + value.option);
		},
		saveOption(name, option) {
			var id = this.dbId(name, option);

			var word = document.getElementById(option);
			var c = " highlight"

			var value = word.className.includes(c);

			this.$db.options.put({
				id: id,
				option: value
			}).catch(function(error){
				console.log("error saving option" + error);
			});

			console.log("option saved: " + id + ", " + value);
		},
		setupCrossText(t){
				var words = t.innerHTML.split( " " );
				this.$refs["crossingText"].innerHTML="";
				for (var i = 0; i < words.length; i++) {
				this.$refs["crossingText"].innerHTML += '<span class="crossable" id="crt' + i + '">' + words[i] + "</span>" + " ";
				console.log(words[i]);
				}
				document.querySelectorAll('.crossable').forEach(item => {
					item.addEventListener('click', () => {
					this.crossWord(item.id);
					this.saveOption('crossingText', item.id);
					})
				})
			},
		crossWord(id){
				var word = document.getElementById(id);
				var c = " highlight"
				if (word.className.includes(c)) {
					word.className = word.className.replace(c, "")
				}
				else
				{
					word.className += c;
				}
			}
		},
		mounted(){
			this.setupCrossText(this.$refs["crossingText"]);
			document.querySelectorAll('.crossable').forEach(item => {
				this.loadOption('crossingText', item.id);
			})
		}
	}
</script>